export default __webpack_public_path__ + "static/media/customer-journey-mapping-template.1a163b2b.pptx";